var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1369 16.9024L25.7882 28.1683H22.6481L16.4045 18.9753V18.9747L15.4878 17.6252L8.19434 6.88562H11.3344L17.2203 15.5529L18.1369 16.9024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3262 0H3.67377C1.64486 0 0 1.69324 0 3.78183V31.2182C0 33.3068 1.64486 35 3.67377 35H30.3262C32.3551 35 34 33.3068 34 31.2182V3.78183C34 1.69324 32.3551 0 30.3262 0ZM21.6863 29.6807L15.3682 20.215L7.45783 29.6807H5.4134L14.4604 18.8555L5.4134 5.30134H12.3137L18.2965 14.2647L25.7871 5.30134H27.8315L19.2046 15.6245H19.204L28.5866 29.6807H21.6863Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.45fc7627d23a2284f3c3c4242563acc1.svg";
export { ForwardRef as ReactComponent };